export default {
      id: "certificate-usage",
      viewBox: "0 0 18 20",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#certificate",
      toString: function () {
        return this.url;
      }
    }